module.exports = __webpack_public_path__ + "assets/views/01_aboutPadcev/moa_vid_poster.png";